// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatar[data-v-3c7edb24]{width:2.375rem;cursor:pointer;position:relative}.avatar[data-v-3c7edb24],.avatar__img[data-v-3c7edb24]{border-radius:.375rem}.avatar__img[data-v-3c7edb24]{width:100%;height:2.25rem}.avatar__badge[data-v-3c7edb24]{position:absolute;right:-.5rem;top:-.5rem}@media(min-width:84em){.avatar[data-v-3c7edb24]{width:3.06rem}.avatar__img[data-v-3c7edb24]{width:100%;height:3rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
